import { keys } from 'app/config/keys';

export function logError(error: unknown, componentStack?: null | string, ownerStack?: null | string): void {
  if (keys.__DEV__) {
    console.error(error);

    if (componentStack) {
      console.error(componentStack);
    }

    if (ownerStack) {
      console.error(ownerStack);
    }
  }

  // logging to 3rd party service could be added here
}
